import request from '@/http/request'
import{  
    getScoredRuleInfoBySetId, 
    getScoredRuleBySetId,
    scoredRuleSave,
    scoredRuleExecute,
    getScoredDetailBySetId,
    getScoredStudentListBySetId,
    getScoredStudentListBySetIdExport,
    confirmScoredRuleBySetId

} from '@/http/api'

export const getScoredRuleInfoBySetIdFn = (data) => {
    return request({
        url: getScoredRuleInfoBySetId,
        data
    })
}

export const getScoredRuleBySetIdFn = (data) => {
    return request({
        url: getScoredRuleBySetId,
        data
    })
}

export const scoredRuleSaveFn = (data) => {
    return request({
        url: scoredRuleSave,
        data
    })
}

export const scoredRuleExecuteFn = (data) => {
    return request({
        url: scoredRuleExecute,
        data
    })
}

export const getScoredDetailBySetIdFn = (data) => {
    return request({
        url: getScoredDetailBySetId,
        data
    })
}

export const getScoredStudentListBySetIdFn = (data) => {
    return request({
        url: getScoredStudentListBySetId,
        data
    })
}

export const getScoredStudentListBySetIdExportFn = (data) => {
    return request({
        url: getScoredStudentListBySetIdExport,
        data
    })
}

export const confirmScoredRuleBySetIdFn = (data) => {
    return request({
        url: confirmScoredRuleBySetId,
        data
    })
}

